module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/logo-a38b87043e34dcc1c51de4b3b87d0840.png";